import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 12,
    width: '100%',
    maxWidth: 560,
    margin: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: '#0B1736',
  },
  subtitle: {
    color: '#5F7394',
    fontSize: 16,
    marginBottom: theme.spacing(2),
    lineHeight: 1.35,
  },
  infoCard: {
    border: '1px solid #D7DFEC',
    borderRadius: 14,
    background: '#F8FAFF',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  infoHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  lessonName: {
    fontWeight: 700,
    fontSize: 18,
    color: '#0B1736',
    marginBottom: theme.spacing(1),
  },
  editButton: {
    color: '#5F7394',
    marginTop: -4,
  },
  fieldIcon: {
    color: '#5F7394',
    marginRight: theme.spacing(1),
  },
  rowInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#5F7394',
    fontSize: 16,
    marginBottom: theme.spacing(0.6),
  },
  switch: {
    borderRadius: 12,
    background: '#ECF1F7',
    padding: 4,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 4,
  },
  switchBtn: {
    border: 'none',
    borderRadius: 10,
    background: 'transparent',
    color: '#5F7394',
    fontWeight: 700,
    fontSize: 18,
    padding: theme.spacing(1),
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  activeSwitchBtn: {
    background: '#FFFFFF',
    color: '#0B1736',
    boxShadow: '0 1px 2px rgba(11, 23, 54, 0.15)',
  },
  qrBox: {
    margin: theme.spacing(4, 'auto', 2),
    width: 230,
    height: 230,
    border: '1px solid #D7DFEC',
    borderRadius: 12,
    background: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  qrImage: {
    width: 150,
    height: 150,
  },
  qrHelp: {
    textAlign: 'center',
    color: '#5F7394',
    fontSize: 17,
    marginBottom: theme.spacing(2),
  },
  codeWrap: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
    margin: theme.spacing(4, 0, 2),
  },
  digit: {
    width: 52,
    height: 64,
    borderRadius: 10,
    border: '1px solid #D7DFEC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 40,
    color: '#0B1736',
    background: '#FFFFFF',
  },
  codeHelp: {
    textAlign: 'center',
    color: '#5F7394',
    fontSize: 16,
  },
  expires: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: '#5F7394',
    fontSize: 16,
  },
  footer: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.2),
    padding: 0,
  },
  closeBtn: {
    background: '#FFFFFF',
    border: '1px solid #D7DFEC',
    color: '#0B1736',
    borderRadius: 10,
    fontWeight: 700,
    minWidth: 90,
  },
  generateBtn: {
    minWidth: 150,
  },
}));
